import { TextField } from "../../../components/ui";
import { toast } from "../../../components/ui/Toast/useToast";
import { ToggleButton } from "../../../components/ui/Toggle/ToggleButton";
import { UploadFile } from "../../../components/ui/uploadFile";
import { useDownloadForm } from "../../../hooks/react-query/useNewService";

export const BookingStepFour = ({ state, dispatch }) => {
  // Step One: Here the user chooses the types of services
  // he/she wants to book an appointment for.

  // LOCAL STATE:
    const { refetch, isFetching } = useDownloadForm(
      'AccidentReport.pdf'
    );

  // FETCH DATA:

  // LOCAL VARIABLES:

  // USE EFFECTS:

  // HANDLERS & FUNCTIONS

    const handleAccidentReportDownloadClick = () => {
        if (!isFetching) {
            refetch();
        }
    };

    const handleUpload = (mode, file, index) => {
        if (mode === 'upload') {
            if(file) {
                dispatch({
                    type: "SET_BODYWORK",
                    option:
                        index === 4
                        ? "accidentReport"
                        : `bodyWorkPhotos_${index}`,
                    value: file,
                });
            }
        }
    };

    const handleFileReject = () => {
        toast({
            variant: 'destructive',
            description: 'Μη επιτρεπτός τύπος αρχείου',
        });
    };

    const numbering = (type) => {
        switch (type) {
            case "service":
                return (state?.options?.tyresChange || state?.options?.bodyWork ) ? "1. " : ""
            case "tyres":
                let number=""
                if(state?.options?.standarizedService) number="2. "
                if(!state?.options?.standarizedService && state?.options?.bodyWork) number="1. "
                return number;
            case "bodywork":
                let numbert=""
                if(state?.options?.standarizedService && state?.options?.tyresChange) numbert=3
                if(state?.options?.standarizedService && !state?.options?.tyresChange) numbert=2
                if(!state?.options?.standarizedService && state?.options?.tyresChange) numbert=2
                if(!state?.options?.standarizedService && !state?.options?.tyresChange) numbert=0
                return numbert;
            default:
                return ""
        }
    }

  return (
    <div className='flex items-center'>
      <div className="flex flex-col pb-10 w-full items-start">
        {state?.options?.standarizedService && <>
            <h4 className='pb-6'>{
                `${numbering("service")}Υπάρχει κάτι που πρέπει να γνωρίζουμε για το αυτοκίνητό σου;`
                }</h4>
            <p className='mb-3 text-lg font-semibold'>Παρατηρήσεις (προαιρετικό)</p>
            <TextField 
                className='w-[568px] mb-20' 
                error={""} 
                type={'textarea'} 
                placeholder={"Π.χ. θόρυβος στα φρένα"}
                onChange={(e) => {
                    dispatch({
                        type: "SET_STANDARIZEDSERVICE",
                        option: "additionalComments",
                        value: e.target.value,
                    });
                }} />
        </>}
        {state?.options?.tyresChange &&
            <>
                <h4>{
                    `${numbering("tyres")}Προτεινόμενες διαστάσεις ελαστικών κατασκευαστή.`
                }</h4>
                <h4 className='font-normal pb-6'>Μπορείς να τις αλλάξεις, αν χρειάζεται.</h4>
                <div className="flex flex-row gap-4">
                    <TextField 
                        className="w-[164px] h-12" 
                        labelClassName="w-[164px] text-grenite" 
                        error={""} 
                        type={'number'} 
                        step={5} 
                        min={100} 
                        max={999} 
                        value={state?.tyresChange?.frontTyreWidth}
                        label={`Πλάτος πέλματος ${!state?.tyresChange?.rearSameAsFront ? 'εμπρόσθιων' : ""} ελαστικών`}  
                        onChange={(e) => {
                            dispatch({
                                type: "SET_TYRESCHANGE",
                                option: "frontTyreWidth",
                                value: e.target.value,
                            });
                        }} 
                        placeholder={'235'} />
                    <TextField 
                        className="w-[164px] h-12" 
                        labelClassName="w-[164px] text-grenite" 
                        error={""} 
                        type={'number'} 
                        min={10} 
                        max={99} 
                        value={state?.tyresChange?.frontTyreHeight}
                        label={`Ύψος/προφίλ ${!state?.tyresChange?.rearSameAsFront ? 'εμπρόσθιων' : ""} ελαστικών`} 
                        step={5}  
                        onChange={(e) => {
                            dispatch({
                                type: "SET_TYRESCHANGE",
                                option: "frontTyreHeight",
                                value: e.target.value,
                            });
                        }} 
                        placeholder={'55'} />
                    <TextField 
                        className="w-[164px] h-12" 
                        labelClassName="w-[164px] text-grenite" 
                        error={""} 
                        type={'number'} 
                        min={10} 
                        max={99} 
                        value={state?.tyresChange?.frontTyreDiameter}
                        label={`Εσωτερική διάμετρος ${!state?.tyresChange?.rearSameAsFront ? 'εμπρόσθιων' : ""} ελαστικών`} 
                        step={1} 
                        placeholder="17" 
                        onChange={(e) => {
                            dispatch({
                                type: "SET_TYRESCHANGE",
                                option: "frontTyreDiameter",
                                value: e.target.value,
                            });
                        }} />
                </div>
                <div className="flex flex-row gap-4 pb-6">
                    {!state?.tyresChange?.rearSameAsFront && <>
                        <TextField 
                            className="w-[164px] h-12" 
                            labelClassName="w-[164px] text-grenite" 
                            type={'number'} 
                            min={100} 
                            max={999} 
                            label="Πλάτος πέλματος οπίσθιων ελαστικών" 
                            step={5} 
                            placeholder= "235"  
                            value={state?.tyresChange?.rearTyreWidth}
                            error={""} 
                            onChange={(e) => {
                                dispatch({
                                    type: "SET_TYRESCHANGE",
                                    option: "rearTyreWidth",
                                    value: e.target.value,
                                });
                            }}/>
                        <TextField 
                            className="w-[164px] h-12" 
                            labelClassName="w-[164px] text-grenite" 
                            type={'number'} 
                            min={10} 
                            max={99} 
                            label="Ύψος/προφίλ οπίσθιων ελαστικών" 
                            step={5} 
                            placeholder= "55"  
                            value={state?.tyresChange?.rearTyreHeight}
                            error={""} 
                            onChange={(e) => {
                                dispatch({
                                    type: "SET_TYRESCHANGE",
                                    option: "rearTyreHeight",
                                    value: e.target.value,
                                });
                            }}/>
                        <TextField 
                            className="w-[164px] h-12" 
                            labelClassName="w-[164px] text-grenite" 
                            type={'number'} 
                            min={10} 
                            max={99} 
                            label="Εσωτερική διάμετρος οπίσθιων ελαστικών" 
                            step={1} 
                            placeholder= "17" 
                            value={state?.tyresChange?.rearTyreDiameter}
                            error={""} 
                            onChange={(e) => {
                                dispatch({
                                    type: "SET_TYRESCHANGE",
                                    option: "rearTyreDiameter",
                                    value: e.target.value,
                                });
                            }}/>
                    </>}
                </div>
                {state?.tyreRunFlat && <div className="flex gap-2 items-center pb-5">
                    <ToggleButton checked={state?.tyreRunFlat} 
                        className='data-[state=checked]:bg-[#D4002A]'
                        disabled={state?.tyreRunFlat}
                        onCheckedChange={(value) => {
                            dispatch({
                                type: "SET_TYRESCHANGE",
                                option: "tyreRunFlat",
                                value: value,
                            });
                    }} />
                    <p>Runflat ελαστικά</p>
                </div>}
                <div className="flex gap-2 items-center pb-28">
                    <ToggleButton 
                        className='data-[state=checked]:bg-[#13EF00]'
                        checked={state?.tyresChange?.rearSameAsFront} 
                        onCheckedChange={(value) => {
                            dispatch({
                                type: "SET_TYRESCHANGE",
                                option: "rearSameAsFront",
                                value: value,
                            });
                    }} />
                    <p>Ίδια ελαστικά στους εμπρόσθιους και τους οπίσθιους τροχούς</p>
                </div>
            </>}

            {state?.options?.bodyWork && <>
                <h4 className='pb-2'>{
                    `${numbering("bodywork") > 0 ? `${numbering("bodywork")}. ` : ""}Ανέβασε τη συμπληρωμένη δήλωση ατυχήματος.`
                }</h4>        
                <span className='text-lg pb-4'>
                    {`Κατέβασε τη φόρμα `}
                    <span
                        onClick={()=>{
                            try {
                                handleAccidentReportDownloadClick()
                            } catch(e) {
                                console.warn(e)
                            }
                        }}
                        className="text-lg cursor-pointer font-bold"
                        >
                        εδώ.
                    </span>
                </span>          
                <UploadFile 
                    className='!w-[172px] !max-w-none pb-6' 
                    dropzoneClassName="border-dashed border-[#A5A5A5] max-w-[172px] h-20 w-[172px]" 
                    prevFile={state?.bodyWork?.accidentReport}
                    allowedTypes={['pdf']} 
                    canDelete={false} 
                    onFileChange={(mode, file) => handleUpload(mode, file, 4)} 
                    itemIndex={4} maxFiles={1}
                />
                <h4 className='pb-3'>{`${numbering("bodywork") > 0 ? `${numbering("bodywork")+1}. ` : ""}Συμπλήρωσε παρατηρήσεις για το φανοποιείο.`}</h4>
                <TextField
                    className='w-[568px] mb-6 outline-none focus:outline-none focus:ring-0 focus:shadow-none'
                    error={""}
                    key='step-four-bodywork'
                    type={'textarea'}
                    onChange={(e) => {
                        dispatch({
                            type: "SET_BODYWORK",
                            option: "bodyWork",
                            value: e.target.value,
                        });
                    }} 
                    placeholder={'Π.χ. σημάδι στον προφυλακτήρα'} />

                <h4 className="pb-6">{`${numbering("bodywork") > 0 ? `${numbering("bodywork")+2}. ` : ""}Ανέβασε 3 φωτογραφίες από τη ζημιά.`}</h4>
                <div className="flex flex-row gap-3 w-full pb-5">
                    <UploadFile 
                        className="!w-[172px] !max-w-none"
                        dropzoneClassName="border-dashed rounded-xl border-[#A5A5A5] max-w-[172px] h-20 w-[172px] py-2 px-4" 
                        prevFile={state?.bodyWork?.bodyWorkPhotos_1}
                        allowedTypes={['jpg','png','jpeg','tiff','gif','bpm','webp']} 
                        canDelete={false} 
                        onReject={handleFileReject}
                        onFileChange={(mode, file) => handleUpload(mode, file, 1)}
                        itemIndex={1} maxFiles={1} />
                    <UploadFile 
                        className="!w-[172px] !max-w-none"
                        dropzoneClassName="border-dashed rounded-xl border-[#A5A5A5] max-w-[172px] h-20 w-[172px] py-2 px-4" 
                        prevFile={state?.bodyWork?.bodyWorkPhotos_2}
                        allowedTypes={['jpg','png','jpeg','tiff','gif','bpm','webp']} 
                        canDelete={false} 
                        onReject={handleFileReject}
                        onFileChange={(mode, file) => handleUpload(mode, file, 2)}
                        itemIndex={2} maxFiles={1} />
                    <UploadFile 
                        className="!w-[172px] !max-w-none"
                        dropzoneClassName="border-dashed rounded-xl border-[#A5A5A5] max-w-[172px] h-20 w-[172px] py-2 px-4" 
                        prevFile={state?.bodyWork?.bodyWorkPhotos_3}
                        allowedTypes={['jpg','png','jpeg','tiff','gif','bpm','webp']} 
                        canDelete={false} 
                        onReject={handleFileReject}
                        onFileChange={(mode, file) => handleUpload(mode, file, 3)}
                        itemIndex={3} maxFiles={1} />
                </div>
                {/* Maybe turn this into validation? Depending design... */}
                {/* {<p className="text-primary text-label">Ανέβασε 3 φωτογραφίες</p>} */}
            </>}

        </div>
    </div>
  );
};
